module.exports = __webpack_public_path__ + "img/unknown-avtar.55221557.png";